import React from 'react';
import {
    IFloatingBubbleContent,
    IFloatingBubbleHandler
} from '../../../floating-bubbles/floating-bubbles.service.interface';
import {CasinofiedComponentBase} from './casinofied-component-base';

export class CasinofiedBubbleComponent extends CasinofiedComponentBase implements IFloatingBubbleContent {

    private _floatingBubbleHandler: IFloatingBubbleHandler = null;

    protected async _displayComponent(componentData: any): Promise<void> {
        this._floatingBubbleHandler = this.services.floatingBubbles.addBubble(this);
        await super._displayComponent(componentData);

    }

    /**
     * IFloatingBubbleContent.id
     */
    get id(): string {
        return this._containerID;
    }

    /**
     * IFloatingBubbleContent.visible
     */
    get isVisible(): boolean {
        return true;
    }

    /**
     * IFloatingBubbleContent.render
     */
    render(): React.ReactNode {
        return (<></>); // we only need to render an empty fragment. The FloatingBubblesComponent will render a div for us
    }

    remove() {
        try {
            super.remove();
        }
        finally {
            this._floatingBubbleHandler?.remove();
        }
    }
}
